// extracted by mini-css-extract-plugin
export default {"root":"_3sJrO","valign-top":"QP6py","valignTop":"QP6py","valign-middle":"_3VpOy","valignMiddle":"_3VpOy","valign-bottom":"dfDvd","valignBottom":"dfDvd"};